var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2558 73.2227C38.0331 73.2227 39.4549 71.8009 39.4549 70.0236C39.4549 68.2464 38.0331 66.8246 36.2558 66.8246C34.4786 66.8246 33.0568 68.2464 33.0568 70.0236C33.0568 71.8009 34.4786 73.2227 36.2558 73.2227Z",
    fill: "#EE2F37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4835 68.2465C19.9053 68.9574 21.6825 68.6019 22.3934 67.1801C23.4598 65.7583 22.7489 63.9811 21.3271 62.9147C19.9053 62.2038 18.128 62.5593 17.4171 64.3365C16.3508 65.7583 17.0617 67.5356 18.4835 68.2465Z",
    fill: "#EE2F37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62074 55.4502C5.68709 57.2275 7.81979 57.9384 9.59704 56.872C11.3743 55.8057 12.0852 53.673 11.0188 51.8957C9.95249 50.1185 7.81979 49.763 6.04254 50.4739C4.26529 51.5403 3.90984 53.673 4.62074 55.4502Z",
    fill: "#EE2F37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 37.3222C0 39.4549 1.4218 40.8767 3.5545 40.8767C5.33175 40.8767 7.109 39.4549 7.109 37.3222C7.109 35.5449 5.33175 33.7677 3.5545 33.7677C1.4218 33.7677 0 35.5449 0 37.3222Z",
    fill: "#EE2F37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62077 19.1944C3.55442 20.9716 4.26532 23.4598 6.04257 24.5261C7.81982 25.5925 10.308 24.8816 11.3743 23.1043C12.4407 20.9716 11.7298 18.8389 9.95253 17.7726C7.81982 16.7062 5.68712 17.0617 4.62077 19.1944Z",
    fill: "#EE2F37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7724 5.33179C15.6397 6.39814 14.9288 9.24174 15.9952 11.3744C17.417 13.1517 19.9051 13.8626 22.0378 12.7962C24.1705 11.7299 24.8814 8.88629 23.4596 6.75359C22.3933 4.97634 19.9051 4.26544 17.7724 5.33179Z",
    fill: "#EE2F37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.256 0C33.7678 0 31.6351 2.1327 31.6351 4.62085C31.6351 7.109 33.7678 9.2417 36.256 9.2417C38.7441 9.2417 40.8768 7.109 40.8768 4.62085C40.8768 2.1327 38.7441 0 36.256 0Z",
    fill: "#EE2F37"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0946 4.6208C52.6065 2.84354 49.4074 3.9099 47.9856 6.39805C46.5638 8.8862 47.2747 12.0853 49.7629 13.5071C52.6065 14.9289 55.8055 14.218 57.2273 11.7298C58.6491 9.24165 57.5828 6.0426 55.0946 4.6208Z",
    fill: "#EE2F37"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6684 18.128C67.8911 15.2844 64.3366 14.2181 61.493 15.9953C58.6494 17.4171 57.5831 20.9716 59.3603 23.8152C61.1376 26.6588 64.6921 27.7252 67.5357 26.3034C70.3793 24.5261 71.4456 20.9716 69.6684 18.128Z",
    fill: "#EE2F37"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 37.3222C75 34.1232 72.1564 31.2796 68.9573 31.2796C65.4028 31.2796 62.9147 34.1232 62.9147 37.3222C62.9147 40.5213 65.4028 43.3649 68.9573 43.3649C72.1564 43.3649 75 40.5213 75 37.3222Z",
    fill: "#EE2F37"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.379 56.8722C72.1562 54.0286 71.0899 49.7632 67.8908 47.9859C64.6918 46.2086 60.7818 47.275 59.0046 50.4741C56.8719 53.6731 57.9382 57.5831 61.1373 59.3603C64.3363 61.1376 68.6017 60.0712 70.379 56.8722Z",
    fill: "#EE2F37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.6acbeb2d91b6a8e0cea27e64e701119c.svg";
export { ForwardRef as ReactComponent };